import { Dropdown } from "../global";
import { initSection } from "../utils";

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.body.dataset.template == "collection") {
    initSection("drop-down-container", Dropdown);
  }
});
